"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xLargeUp = exports.upToSmall = exports.upToMedium = exports.upToLarge = exports.smallUp = exports.smallToMedium = exports.smallToLarge = exports.mediumUp = exports.mediumToLarge = exports.mediaQueries = exports.largeUp = exports.largeToXLarge = exports.breakpoints = void 0;
var breakpoints = exports.breakpoints = {
  small: 440,
  medium: 768,
  large: 992,
  xLarge: 1200
};
var upToSmall = exports.upToSmall = "@media (max-width: ".concat(breakpoints.small, "px)");
var smallUp = exports.smallUp = "@media (min-width: ".concat(breakpoints.small, "px)");
var upToMedium = exports.upToMedium = "@media (max-width: ".concat(breakpoints.medium, "px)");
var mediumUp = exports.mediumUp = "@media (min-width: ".concat(breakpoints.medium, "px)");
var upToLarge = exports.upToLarge = "@media (max-width: ".concat(breakpoints.large, "px)");
var largeUp = exports.largeUp = "@media (min-width: ".concat(breakpoints.large, "px)");
var xLargeUp = exports.xLargeUp = "@media (min-width: ".concat(breakpoints.xLarge, "px)");
var smallToLarge = exports.smallToLarge = "@media (min-width: ".concat(breakpoints.small, "px) and (max-width: ").concat(breakpoints.large, "px)");
var smallToMedium = exports.smallToMedium = "@media (min-width: ".concat(breakpoints.small, "px) and (max-width: ").concat(breakpoints.medium, "px)");
var mediumToLarge = exports.mediumToLarge = "@media (min-width: ".concat(breakpoints.medium, "px) and (max-width: ").concat(breakpoints.large, "px)");
var largeToXLarge = exports.largeToXLarge = "@media (min-width: ".concat(breakpoints.large, "px) and (max-width: ").concat(breakpoints.xLarge, "px)");
var mediaQueries = exports.mediaQueries = {
  upToSmall: upToSmall,
  upToMedium: upToMedium,
  upToLarge: upToLarge,
  smallUp: smallUp,
  mediumUp: mediumUp,
  largeUp: largeUp,
  xLargeUp: xLargeUp,
  smallToMedium: smallToMedium,
  smallToLarge: smallToLarge,
  mediumToLarge: mediumToLarge,
  largeToXLarge: largeToXLarge
};
//# sourceMappingURL=breakpoints.js.map